import React, { useState } from "react";
import { getToken } from "./tokenService"; // Import the API service

function App() {
  const [user, setUser] = useState(""); // State for user input
  const [token, setToken] = useState(""); // State for the token response

  const handleGetToken = async () => {
    try {
      const data = await getToken(user); // Call the backend API
      setToken(data.token); // Update the token state
    } catch (error) {
      console.error("Error fetching token:", error);
    }
  };

  return (
    <div>
      <h1>Personal Token Website</h1>
      <input
        type="text"
        placeholder="Enter user"
        value={user}
        onChange={(e) => setUser(e.target.value)}
      />
      <button onClick={handleGetToken}>Get Token</button>
      {token && <p>Token: {token}</p>}
    </div>
  );
}

export default App